import React, { useEffect, useState } from "react";
import axios from "axios";
import dropdownIcon from "../../Assets/arrow-down.svg";
import "./TrainingHistory.css";
import { FaStar } from "react-icons/fa";
import { lightHaptic } from "../../native/capacitor";
import {
  enqueueFavoriteToggle,
  getCachedSessions,
  setCachedSessions,
} from "../../offline/sessionOffline";

const RestoreSessionList = ({ userId, onRestore, isMobile, isOnline = true }) => {
  const [sessions, setSessions] = useState([]);
  const [expandedDates, setExpandedDates] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!userId) return;
    const cached = getCachedSessions(userId);
    if (cached?.sessions?.length) {
      setSessions(cached.sessions);
      setIsLoading(false);
    }

    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/api/sessions/${userId}`)
      .then((res) => {
        const { sessions } = res.data;
        setSessions(sessions);
        setCachedSessions(userId, sessions);
        setIsLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching sessions", err);
        setIsLoading(false);
      });
  }, [userId]);

  const toggleDateGroup = (date) => {
    setExpandedDates((prev) => ({ ...prev, [date]: !prev[date] }));
  };

  const toggleFavorite = async (sessionId, currentVal) => {
    lightHaptic();
    setSessions((prev) =>
      prev.map((s) =>
        s.id === sessionId ? { ...s, is_favorite: !currentVal } : s
      )
    );

    if (!isOnline) {
      enqueueFavoriteToggle({ sessionId, userId });
      return;
    }

    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/toggle-favorite`,
        { sessionId, userId }
      );
      setSessions(prev =>
        prev.map(s =>
          s.id === sessionId ? { ...s, is_favorite: data.isFavorite } : s
        )
      );
    } catch (err) {
      console.error("toggle favorite error:", err);
      enqueueFavoriteToggle({ sessionId, userId });
    }
  };  

  useEffect(() => {
    if (!userId || !sessions.length) return;
    setCachedSessions(userId, sessions);
  }, [userId, sessions]);

  const groupedByDate = sessions
  .filter((s) => s.status !== "processing")
  .reduce((acc, session) => {
    const dateObj = new Date(session.created_at);
    const day = dateObj.toLocaleDateString("en-US", {
      timeZone: "America/New_York",
      weekday: "long",
    });
    const formattedDate = dateObj.toLocaleDateString("en-US", {
      timeZone: "America/New_York",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
    const displayDate = `${day} – ${formattedDate}`;
    if (!acc[displayDate]) acc[displayDate] = [];
    acc[displayDate].push(session);
    return acc;
  }, {});

  const formatDateTime = (isoString) => {
    const options = {
      timeZone: "America/New_York",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    };
    return new Date(isoString).toLocaleTimeString("en-US", options) + " EST";
  };

  if (!userId) {
    return (
      <div className="training-container loading-state">
        <div className="loading-message">
          <p>👤 This is a guest session. Session history is not available.</p>
        </div>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="training-container loading-state">
        <div className="loading-message">
          <div className="spinner" />
          <p>Loading your sessions...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="training-container fade-in-training">
      <div className="training-sidebar">
        <h2>Restore Session</h2>
        {Object.keys(groupedByDate).length === 0 ? (
          <div className="empty-message">
            <p>No sessions found.</p>
          </div>
        ) : (
          <ul className="date-group-list">
            {Object.keys(groupedByDate).map((date) => (
              <li key={date} className="date-group">
                <div className="date-toggle" onClick={() => toggleDateGroup(date)}>
                  <img
                    src={dropdownIcon}
                    alt="toggle"
                    className={`dropdown-arrow ${expandedDates[date] ? "" : "rotated"}`}
                  />
                  {date}
                </div>
                <div className={`session-collapse ${expandedDates[date] ? "expanded" : ""}`}>
                  {expandedDates[date] && (
                    <ul className="session-list">
                      {groupedByDate[date].map((s, index) => (
                        <li key={s.id}>
                       <button
                          className={`session-button`}
                          onClick={() => onRestore(s)}
                          >
                          <div className="session-row">
                            <div className="session-left">
                              <div className="session-info-row">
                                <span className="session-number">{index + 1}.</span>
                                <span className="session-type">
                                  {s.is_demo ? "Demo Video" : "User Upload"}
                                </span>
                              </div>
                              <span className="session-time">{formatDateTime(s.created_at)}</span>
                            </div>

                            <span
                              className={`favorite-toggle ${s.is_favorite ? "favorited" : "not-favorited"}`}
                              onClick={(e) => {
                                e.stopPropagation();
                                toggleFavorite(s.id, s.is_favorite);
                              }}
                            >
                              <FaStar
                                size={18}
                                color={s.is_favorite ? "#f5b301" : "#bbb"}
                                style={{ fill: s.is_favorite ? "#f5b301" : "#ccc" }}
                              />
                            </span>
                          </div>
                        </button>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default RestoreSessionList;
